// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Company-Details-Title {
  text-align: center;
  font: 700 60px/1.1 "HeadingPro", Arial, sans-serif;
}
@media (max-width: 767.98px) {
  .Company-Details-Title {
    margin: 24px 0;
    font-size: 40px;
  }
}

.Bordered-ContainerRow {
  position: relative;
  top: -5.625rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  font-size: 1.125rem;
}
.Bordered-ContainerRow.Bottom {
  top: -3.5625rem;
}
@media screen and (max-width: 1823px) {
  .Bordered-ContainerRow.Bottom {
    top: -4.6875rem;
  }
}
@media screen and (max-width: 767px) {
  .Bordered-ContainerRow {
    top: -2.1875rem;
  }
}

.Top-Margin {
  margin-top: 3.4375rem;
}

.Heading-Column {
  display: flex;
  align-items: center;
  padding: 22px 30px;
  border: 1px solid #00a4ff;
  border-radius: 8px;
  background: #fff;
  font-weight: bold;
  font-size: 24px;
}
@media (max-width: 991.98px) {
  .Heading-Column {
    margin-bottom: 5px;
    padding: 10px;
  }
}
@media screen and (max-width: 767px) {
  .Heading-Column {
    flex: 0 0 75%;
    font-size: 18px;
  }
}

.Two-ResponsiveColumn {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}
@media screen and (min-width: 1824px) {
  .Two-ResponsiveColumn {
    flex: 0 0 50%;
  }
}

.ChartValue-Container {
  overflow: hidden;
  text-align: center;
  text-transform: uppercase;
  text-overflow: ellipsis;
  font-weight: 700;
  font-size: 60px;
}

.Green-Indicator {
  background: #317af6;
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0.5rem 0;
}

.Red-Indicator {
  background: #fd6383;
  border-radius: 50%;
  width: 1.25rem;
  height: 1.25rem;
  margin: 0.5rem 0;
}

.Chart-Div {
  height: 80px;
  border-radius: 6px;
}

.Square-Indicator {
  margin: 0 30px 0 0;
  background: #fff;
  border-radius: 6px;
  width: 1.875rem;
  height: 1.875rem;
}
@media (max-width: 991.98px) {
  .Square-Indicator {
    margin-right: 10px;
  }
}

.Gradient-Line {
  position: relative;
  margin: 0 50px;
  width: 100%;
  height: 5px;
}
@media (max-width: 991.98px) {
  .Gradient-Line {
    margin: 0;
  }
}

.Row-Chart {
  margin: 0 50px;
}
@media (max-width: 991.98px) {
  .Row-Chart {
    margin: 0;
  }
}

.Gradient-Round {
  position: absolute;
  transform: translate(-50%, -45%);
  border-radius: 50%;
  width: 2.1875rem;
  height: 2.1875rem;
}

.Company-Container {
  padding: 0 100px;
  font-size: 24px;
}
.Company-Container :nth-last-child(1) {
  margin-bottom: 0px;
}
.Company-Container :nth-child(even) {
  font-weight: 700;
}
@media screen and (max-width: 800px) {
  .Company-Container {
    padding: 0;
    font-size: 18px;
  }
}

.Chart-Tooltip {
  font-weight: 300;
  font-size: 18px;
}
@media (max-width: 991.98px) {
  .Chart-Tooltip {
    font-size: 16px;
  }
}

.Grey-Background {
  margin-bottom: -70px;
  padding: 85px 0 100px;
}
@media screen and (max-width: 800px) {
  .Grey-Background {
    padding: 50px 0 65px;
  }
}

@media screen and (max-width: 800px) {
  .SpeedMobile_MarginBottom {
    margin-bottom: -73px;
  }
}

.Speedometer-PlaceHolder {
  margin-top: 0.5rem;
  height: 33px;
  border-radius: 17px;
  background-image: linear-gradient(to right, #00a4ff, #00a4ff 24%, #ffe13e 24%, #ffe13e 50%, #fab723 50%, #fab723 76%, #fd6383 76%, #bb0611);
}

.Speedometer-PlaceHolderText {
  display: flex;
  justify-content: space-between;
  margin-top: 0.5rem;
  color: #2b2b2b;
  font-weight: 300;
  font-size: 18px;
}
.Speedometer-PlaceHolderText strong {
  text-align: center;
}

.Performance-Report {
  margin-top: 5rem;
}
.Performance-Report .Icon {
  color: #00ff7f;
  font-size: 96px;
}

.Speedometers .Speedometer-Heading {
  margin-top: 2.5rem;
  text-align: center;
  font-weight: 700;
}
.Speedometers .Speedometer-Heading::after {
  display: block;
  flex-basis: 100%;
  margin: 0 0 24px;
  height: 1px;
  background-image: linear-gradient(to right, rgba(0, 255, 127, 0) 0%, #00ff7f 50%, rgba(0, 255, 127, 0) 100%);
  content: "";
}`, "",{"version":3,"sources":["webpack://./src/pages/DetailsPage.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./src/assets/scss/helpers/_variable.scss","webpack://./src/assets/scss/helpers/_mixins.scss"],"names":[],"mappings":"AAEA;EACE,kBAAA;EACA,kDAAA;AADF;ACsEI;EDvEJ;IAKI,cAAA;IACA,eAAA;EAAF;AACF;;AAGA;EACE,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,6BAAA;EACA,mBAAA;AAAF;AACE;EACE,eAAA;AACJ;AAAI;EAFF;IAGI,eAAA;EAGJ;AACF;AADE;EAbF;IAcI,eAAA;EAIF;AACF;;AADA;EACE,qBAAA;AAIF;;AADA;EACE,aAAA;EACA,mBAAA;EAEA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBE/BM;EFiCN,iBAAA;EACA,eAAA;AAEF;AC2BI;EDvCJ;IAaI,kBAAA;IACA,aAAA;EAGF;AACF;AADE;EAjBF;IAkBI,aAAA;IACA,eAAA;EAIF;AACF;;AADA;EACE,mBAAA;EACA,oBAAA;AAIF;AAFE;EAJF;IAKI,aAAA;EAKF;AACF;;AAIA;EACE,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,uBAAA;EACA,gBAAA;EACA,eAAA;AADF;;AA6BA;EGrGE,mBDCK;ECAL,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AH4EF;;AAyBA;EGzGE,mBDUK;ECTL,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AHoFF;;AAqBA;EACE,YAAA;EACA,kBAAA;AAlBF;;AAqBA;EACE,kBAAA;EGrGA,gBDTM;ECUN,kBAAA;EACA,eAAA;EACA,gBAAA;AHoFF;ACjCI;ED8CJ;IAKI,kBAAA;EAdF;AACF;;AAiBA;EACE,kBAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;AAdF;AC7CI;EDuDJ;IAOI,SAAA;EAbF;AACF;;AAgBA;EACE,cAAA;AAbF;ACtDI;EDkEJ;IAII,SAAA;EAZF;AACF;;AAeA;EACE,kBAAA;EACA,gCAAA;EGxIA,kBAAA;EACA,gBAAA;EACA,iBAAA;AH6HF;;AAcA;EACE,gBAAA;EACA,eAAA;AAXF;AAaE;EACE,kBAAA;AAXJ;AAaE;EACE,gBAAA;AAXJ;AAcE;EAXF;IAYI,UAAA;IACA,eAAA;EAXF;AACF;;AAcA;EAEE,gBAAA;EACA,eAAA;AAZF;ACzFI;EDkGJ;IAMI,eAAA;EAXF;AACF;;AAcA;EACE,oBAAA;EACA,qBAAA;AAXF;AAaE;EAJF;IAKI,oBAAA;EAVF;AACF;;AAcE;EADF;IAEI,oBAAA;EAVF;AACF;;AAaA;EACE,kBAAA;EACA,YAAA;EACA,mBAAA;EACA,2IAAA;AAVF;;AAuBA;EACE,aAAA;EACA,8BAAA;EACA,kBAAA;EACA,cErMqB;EFsMrB,gBAAA;EACA,eAAA;AApBF;AAsBE;EACE,kBAAA;AApBJ;;AAwBA;EACE,gBAAA;AArBF;AAuBE;EACE,cE1MiB;EF2MjB,eAAA;AArBJ;;AA0BE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;AAvBJ;AAyBI;EACE,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,4GAAA;EAMA,WAAA;AA5BN","sourcesContent":["@import '../assets/scss/helpers/component';\n\n.Company-Details-Title {\n  text-align: center;\n  font: 700 60px/1.1 $font-family-alt;\n\n  @include media-breakpoint-down(sm) {\n    margin: 24px 0;\n    font-size: 40px;\n  }\n}\n\n.Bordered-ContainerRow {\n  position: relative;\n  top: rem(-90px);\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-around;\n  font-size: rem(18px);\n  &.Bottom {\n    top: rem(-57px);\n    @media screen and (max-width: 1823px) {\n      top: rem(-75px);\n    }\n  }\n  @media screen and (max-width: 767px) {\n    top: rem(-35px);\n  }\n}\n\n.Top-Margin {\n  margin-top: rem(55px);\n}\n\n.Heading-Column {\n  display: flex;\n  align-items: center;\n  // justify-content: center;\n  padding: 22px 30px;\n  border: 1px solid $gbp-blue;\n  border-radius: 8px;\n  background: $white;\n  // color: $black;\n  font-weight: bold;\n  font-size: 24px;\n\n  @include media-breakpoint-down(md) {\n    margin-bottom: 5px;\n    padding: 10px;\n  }\n\n  @media screen and (max-width: 767px) {\n    flex: 0 0 75%;\n    font-size: 18px;\n  }\n}\n\n.Two-ResponsiveColumn {\n  flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n\n  @media screen and (min-width: 1824px) {\n    flex: 0 0 50%;\n  }\n}\n\n// .Border-TopMobileOnly {\n//   @media screen and (max-width: 800px) {\n//     border-top: 1px solid $light-blue;\n//   }\n// }\n\n.ChartValue-Container {\n  overflow: hidden;\n  text-align: center;\n  text-transform: uppercase;\n  text-overflow: ellipsis;\n  font-weight: 700;\n  font-size: 60px;\n\n  // @media screen and (min-width: 801px) {\n  //   height: 150px;\n\n  //   .Heading {\n  //     font-weight: lighter;\n  //     font-size: 120px;\n  //   }\n  // }\n  // @media screen and (min-width: 1824px) {\n  //   height: 175px;\n\n  //   .Heading {\n  //     font-weight: lighter;\n  //     font-size: 140px;\n  //   }\n  // }\n  // @media screen and (max-width: 767px) {\n  //   width: rem(200px);\n\n  //   .Heading {\n  //     font-weight: bold;\n  //     font-size: rem(50px);\n  //   }\n  // }\n}\n\n.Green-Indicator {\n  @include color-indicator($blue);\n}\n\n.Red-Indicator {\n  @include color-indicator($pink);\n}\n\n.Chart-Div {\n  height: 80px;\n  border-radius: 6px;\n}\n\n.Square-Indicator {\n  margin: 0 30px 0 0;\n\n  @include color-square-indicator($white);\n  @include media-breakpoint-down(md) {\n    margin-right: 10px;\n  }\n}\n\n.Gradient-Line {\n  position: relative;\n  margin: 0 50px;\n  width: 100%;\n  height: 5px;\n\n  @include media-breakpoint-down(md) {\n    margin: 0;\n  }\n}\n\n.Row-Chart {\n  margin: 0 50px;\n\n  @include media-breakpoint-down(md) {\n    margin: 0;\n  }\n}\n\n.Gradient-Round {\n  position: absolute;\n  transform: translate(-50%, -45%);\n\n  @include color-md-indicator;\n}\n\n.Company-Container {\n  padding: 0 100px;\n  font-size: 24px;\n\n  :nth-last-child(1) {\n    margin-bottom: 0px;\n  }\n  :nth-child(even) {\n    font-weight: 700;\n  }\n\n  @media screen and (max-width: 800px) {\n    padding: 0;\n    font-size: 18px;\n  }\n}\n\n.Chart-Tooltip {\n  // color: $highlight-text-color;\n  font-weight: 300;\n  font-size: 18px;\n\n  @include media-breakpoint-down(md) {\n    font-size: 16px;\n  }\n}\n\n.Grey-Background {\n  margin-bottom: -70px;\n  padding: 85px 0 100px;\n\n  @media screen and (max-width: 800px) {\n    padding: 50px 0 65px;\n  }\n}\n\n.SpeedMobile_MarginBottom {\n  @media screen and (max-width: 800px) {\n    margin-bottom: -73px;\n  }\n}\n\n.Speedometer-PlaceHolder {\n  margin-top: 0.5rem;\n  height: 33px;\n  border-radius: 17px;\n  background-image: linear-gradient(\n    to right,\n    $gbp-blue,\n    $gbp-blue 24%,\n    $golden 24%,\n    $golden 50%,\n    $accent4 50%,\n    $accent4 76%,\n    $pink 76%,\n    $maroon\n  );\n}\n\n.Speedometer-PlaceHolderText {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 0.5rem;\n  color: $highlight-text-color;\n  font-weight: 300;\n  font-size: 18px;\n\n  strong {\n    text-align: center;\n  }\n}\n\n.Performance-Report {\n  margin-top: rem(80px);\n\n  .Icon {\n    color: $gbp-electric-green;\n    font-size: 96px;\n  }\n}\n\n.Speedometers {\n  .Speedometer-Heading {\n    margin-top: rem(40px);\n    text-align: center;\n    font-weight: 700;\n\n    &::after {\n      display: block;\n      flex-basis: 100%;\n      margin: 0 0 24px;\n      height: 1px;\n      background-image: linear-gradient(\n        to right,\n        rgba(0, 255, 127, 0) 0%,\n        $gbp-electric-green 50%,\n        rgba(0, 255, 127, 0) 100%\n      );\n      content: \"\";\n    }\n  }\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @return if($n != null and $n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width. Null for the largest (last) breakpoint.\n// The maximum value is calculated as the minimum of the next one less 0.02px\n// to work around the limitations of `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $next: breakpoint-next($name, $breakpoints);\n  @return if($next, breakpoint-min($next, $breakpoints) - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  $max: breakpoint-max($name, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($name, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Fonts colors\n$primary: #415a77;\n$secondary: #2e2e3a;\n$header-background: #415a77;\n$primary-green: #2afca3;\n$light-grey: #f1f4fb;\n$blue: #317af6;\n$light-blue: #89b8f1;\n$light-green: #8ebbf1;\n$border-light: #d3e1fd;\n$white: #fff;\n$sky-blue: #cad8f2;\n$green: #3cc221;\n$red: #f42b03;\n$golden: #ffe13e;\n$pink: #fd6383;\n$dark-blue: #405873;\n$dark-blue-active: #35485e;\n$pale-grey: #f8fafd;\n$table-border: #c5d5f4;\n$highlight-text-color: #2b2b2b;\n$black: #000000;\n$accent4: #fab723;\n$maroon: #bb0611;\n$dark-blue-link: #263546;\n\n\n$gbp-rich-green: #003825;\n$gbp-electric-green: #00ff7f;\n$gbp-blue: #00a4ff;\n\n$table-border: $gbp-electric-green;\n\n$font-family-base: 'MADETOMMY', Arial, sans-serif;\n$font-family-alt: 'HeadingPro', Arial, sans-serif;\n\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  // xxl: 1440px,\n  // xxxl: 1600px\n);\n\n\n$zi-header: 1000;\n$zi-cookie-overlay: 1100;\n","@function rem($size) {\n  @return $size / 16px * 1rem;\n}\n\n@mixin color-indicator($color) {\n  background: $color;\n  border-radius: 50%;\n  width: rem(20px);\n  height: rem(20px);\n  margin: 0.5rem 0;\n}\n\n@mixin color-md-indicator {\n  border-radius: 50%;\n  width: rem(35px);\n  height: rem(35px);\n}\n\n@mixin color-square-indicator($color) {\n  background: $color;\n  border-radius: 6px;\n  width: rem(30px);\n  height: rem(30px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
